import React, { useState } from 'react';
import { KpiFactsTableData } from '../../../_shared/types';
import { KpiDetailModal } from '../../../_shared/components/KpiDetailModal/KpiDetailModal';
import { KpiCalculationMethodModal } from '../../../_shared/components/KpiCalculationMethodModal/KpiCalculationMethodModal';
import { mockKpiItems } from '../../../_shared/mocks';
import { CardDataDesktop } from './CardDataDesktop';
import { CardDataMobile } from './CardDataMobile';
import styles from './CardData.module.scss';

export function CardData({ content }: { content: KpiFactsTableData[] }) {
  const [sentKpis, setSentKpis] = useState<Set<string>>(new Set());
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [
    isCalculationMethodModalOpen,
    setIsCalculationMethodModalOpen
  ] = useState(false);

  const handleSend = (kpiId: string) => {
    setSentKpis((prev) => new Set(prev).add(kpiId));
  };
  const handleCalculationMethodClick = () => {
    setIsCalculationMethodModalOpen(true);
  };
  const handleCalculationMethodClose = () => {
    setIsCalculationMethodModalOpen(false);
  };

  return (
    <>
      <div className={styles.cards}>
        <div className={styles.desk}>
          <CardDataDesktop
            content={content}
            sentKpis={sentKpis}
            onSend={handleSend}
            onDiscuss={() => setIsModalOpen(true)}
            onMethodologyClick={handleCalculationMethodClick}
          />
        </div>
        <div className={styles.mob}>
          <CardDataMobile
            content={content}
            sentKpis={sentKpis}
            onSend={handleSend}
            onDiscuss={() => setIsModalOpen(true)}
            onMethodologyClick={handleCalculationMethodClick}
          />
        </div>
      </div>

      <KpiDetailModal
        isOpen={isModalOpen}
        isEditing={true}
        isDiscussion={false}
        onClose={() => setIsModalOpen(false)}
        kpi={mockKpiItems[0]}
      />

      <KpiCalculationMethodModal
        isOpen={isCalculationMethodModalOpen}
        onClose={handleCalculationMethodClose}
        notification={'Текст возможного уведомления'}
      />
    </>
  );
}
